import {
	Form,
	Input,
	Radio,
	Checkbox,
	Select,
	DatePicker,
	Flex,
	Typography,
} from "antd";

import QuestionSubOption from "./QuestionSubOption";

export default function QuestionOption(props) {
	const {
		data,
		index,
		setStepPercent,
		currentStep,
		dataSource,
		setDataSource,
		answer,
		subAnswer,
		width,
	} = props;

	const handleChange = (value, x, sub = 0) => {
		console.log("handleChange value, x", value, x);

		let new_value = null;

		if (data && data.question_type === "Text (Open Answer)") {
			let form_question_answer =
				dataSource.form_question_categories[currentStep].form_questions[
					index
				] &&
				dataSource.form_question_categories[currentStep].form_questions[index]
					.answer
					? dataSource.form_question_categories[currentStep].form_questions[
							index
					  ].answer
					: null;

			form_question_answer = form_question_answer
				? JSON.parse(form_question_answer)
				: [];

			form_question_answer[x] = value;
			new_value = JSON.stringify(form_question_answer);
		} else {
			new_value = value;
		}

		let count =
			dataSource.form_question_categories[currentStep].form_questions.length;
		let percent = 100 / count;
		let dataSourceTemp = dataSource;
		let form_question_categories = dataSourceTemp.form_question_categories;
		let form_questions = form_question_categories[currentStep].form_questions;
		form_questions[index] = {
			...form_questions[index],
			answer: sub ? form_questions[index].answer : new_value,
			sub_answer:
				sub === 1
					? new_value
					: sub === 2
					? form_questions[index].sub_answer
					: null,
			sub_sub_answer: sub === 2 ? new_value : null,
		};

		form_question_categories[currentStep] = {
			...form_question_categories[currentStep],
			form_questions,
		};

		dataSourceTemp = {
			...dataSourceTemp,
			form_question_categories,
		};

		let answered = form_questions.filter((item) => item.answer).length;
		setStepPercent(percent * answered);
		setDataSource(dataSourceTemp);
	};

	if (data && data.question_type === "Text (Input)") {
		return (
			<Form.Item
				name={`q_${data.id}`}
				rules={[
					{
						required: data.required ? true : false,
						message: "Please answer the question!",
					},
				]}
			>
				<Input
					placeholder="Answer"
					size="large"
					onBlur={(e) => handleChange(e.target.value)}
				/>
			</Form.Item>
		);
	} else if (data && data.question_type === "Text (Open Answer)") {
		if (data.max_input_field && Number(data.max_input_field) > 0) {
			let inputFields = [];

			for (let x = 0; x < Number(data.max_input_field); x++) {
				inputFields.push(
					<Form.Item
						key={`q_${x}_${data.id}`}
						name={`q_${x}_${data.id}`}
						rules={[
							{
								required: data.required ? true : false,
								message: "Please answer the question!",
							},
						]}
					>
						<Input
							addonBefore={x + 1}
							placeholder={`Answer`}
							size="large"
							onChange={(e) => handleChange(e.target.value, x)}
						/>
					</Form.Item>
				);
			}

			return inputFields;
		} else {
			return (
				<Form.Item
					name={`q_${data.id}`}
					rules={[
						{
							required: data.required ? true : false,
							message: "Please answer the question!",
						},
					]}
				>
					<Input
						placeholder="Answer"
						size="large"
						onChange={(e) => handleChange(e.target.value)}
					/>
				</Form.Item>
			);
		}
	} else if (data && data.question_type === "Number (Input)") {
		return (
			<Form.Item
				name={`q_${data.id}`}
				rules={[
					{
						required: data.required ? true : false,
						message: "Please answer the question!",
					},
				]}
			>
				<Input
					placeholder="Answer"
					size="large"
					type="number"
					onChange={(e) => handleChange(e.target.value)}
				/>
			</Form.Item>
		);
	} else if (data && data.question_type === "Radio (Button)") {
		return (
			<Form.Item shouldUpdate noStyle>
				{() => {
					let form_question =
						dataSource.form_question_categories[currentStep].form_questions[
							index
						] &&
						dataSource.form_question_categories[currentStep].form_questions[
							index
						]
							? dataSource.form_question_categories[currentStep].form_questions[
									index
							  ]
							: null;
					let form_question_answer = form_question.answer
						? form_question.answer
						: null;
					let form_question_answer_sub = form_question.sub_answer
						? form_question.sub_answer
						: null;
					let form_question_options =
						dataSource.form_question_categories[currentStep].form_questions[
							index
						] &&
						dataSource.form_question_categories[currentStep].form_questions[
							index
						].form_question_options
							? dataSource.form_question_categories[currentStep].form_questions[
									index
							  ].form_question_options.find(
									(x) => x.option === form_question_answer
							  )
							: null;

					let sub_option = null;

					if (form_question_options && form_question_options.sub_options) {
						sub_option = form_question_options.sub_options.find(
							(x) => x.option === form_question_answer_sub
						);
					}

					return (
						<>
							<Form.Item
								name={`q_${data.id}`}
								rules={[
									{
										required: data.required ? true : false,
										message: "Please answer the question!",
									},
								]}
							>
								<Radio.Group
									size="large"
									onChange={(e) => handleChange(e.target.value)}
								>
									<Flex vertical="vertical">
										{data.form_question_options
											? data.form_question_options.map((item, index) => {
													return (
														<Radio key={index} value={item.option}>
															{item.option}
														</Radio>
													);
											  })
											: ""}
									</Flex>
								</Radio.Group>
							</Form.Item>

							{form_question_options &&
							form_question_options.question_option ? (
								<Typography.Text strong>
									{form_question_options.question_option}
								</Typography.Text>
							) : null}

							{form_question_options &&
							form_question_options.sub_option_type ? (
								<QuestionSubOption
									data={data}
									subData={form_question_options}
									subAnswer={subAnswer}
									handleChange={handleChange}
									isOthers={
										sub_option && sub_option.scale === "others" ? true : false
									}
								/>
							) : null}
						</>
					);
				}}
			</Form.Item>
		);
	} else if (data && data.question_type === "Checkbox") {
		let disabled = false;

		if (answer && answer.length === Number(data.max_checkbox)) {
			disabled = true;
		}

		return (
			<Form.Item shouldUpdate noStyle>
				{() => {
					let form_question =
						dataSource.form_question_categories[currentStep].form_questions[
							index
						] &&
						dataSource.form_question_categories[currentStep].form_questions[
							index
						]
							? dataSource.form_question_categories[currentStep].form_questions[
									index
							  ]
							: null;
					let form_question_answer = form_question.answer
						? form_question.answer
						: null;
					let form_question_answer_sub = form_question.sub_answer
						? form_question.sub_answer
						: null;
					let form_question_options =
						dataSource.form_question_categories[currentStep].form_questions[
							index
						] &&
						dataSource.form_question_categories[currentStep].form_questions[
							index
						].form_question_options
							? dataSource.form_question_categories[currentStep].form_questions[
									index
							  ].form_question_options.find(
									(x) => x.option === form_question_answer
							  )
							: null;

					let sub_option = null;

					if (form_question_options && form_question_options.sub_options) {
						sub_option = form_question_options.sub_options.find(
							(x) => x.option === form_question_answer_sub
						);
					}

					return (
						<>
							<Form.Item
								name={`q_${data.id}`}
								rules={[
									{
										required: data.required ? true : false,
										message: "Please answer the question!",
									},
								]}
							>
								<Checkbox.Group
									size="large"
									onChange={(e) => handleChange(e)}
									style={{
										width: "100%",
									}}
								>
									<Flex
										vertical="vertical"
										gap={15}
										style={{
											width: "100%",
										}}
									>
										{data.form_question_options
											? data.form_question_options.map((item, index) => {
													return (
														<Flex
															key={index}
															gap={15}
															justify={width < 768 ? "" : "space-between"}
															align={width < 768 ? "" : "center"}
															vertical={width < 768 ? "vertical" : ""}
														>
															<Checkbox
																key={index}
																value={item.option}
																disabled={
																	disabled
																		? answer.find((x) => x === item.option)
																			? false
																			: true
																		: false
																}
															>
																{item.option}
															</Checkbox>
														</Flex>
													);
											  })
											: ""}
									</Flex>
								</Checkbox.Group>
							</Form.Item>

							{form_question_options &&
							form_question_options.question_option ? (
								<Typography.Text strong>
									{form_question_options.question_option}
								</Typography.Text>
							) : null}

							{form_question_options &&
							form_question_options.sub_option_type ? (
								<QuestionSubOption
									data={data}
									subData={form_question_options}
									subAnswer={subAnswer}
									handleChange={handleChange}
									isOthers={
										sub_option && sub_option.scale === "others" ? true : false
									}
								/>
							) : null}
						</>
					);
				}}
			</Form.Item>
		);
	} else if (data && data.question_type === "Select (Dropdown)") {
		return (
			<Form.Item shouldUpdate noStyle>
				{() => {
					let form_question =
						dataSource.form_question_categories[currentStep].form_questions[
							index
						] &&
						dataSource.form_question_categories[currentStep].form_questions[
							index
						]
							? dataSource.form_question_categories[currentStep].form_questions[
									index
							  ]
							: null;
					let form_question_answer = form_question.answer
						? form_question.answer
						: null;
					let form_question_answer_sub = form_question.sub_answer
						? form_question.sub_answer
						: null;
					let form_question_options =
						dataSource.form_question_categories[currentStep].form_questions[
							index
						] &&
						dataSource.form_question_categories[currentStep].form_questions[
							index
						].form_question_options
							? dataSource.form_question_categories[currentStep].form_questions[
									index
							  ].form_question_options.find(
									(x) => x.option === form_question_answer
							  )
							: null;

					let sub_option = null;

					if (form_question_options && form_question_options.sub_options) {
						sub_option = form_question_options.sub_options.find(
							(x) => x.option === form_question_answer_sub
						);
					}

					return (
						<>
							<Form.Item
								name={`q_${data.id}`}
								rules={[
									{
										required: data.required ? true : false,
										message: "Please answer the question!",
									},
								]}
							>
								<Select
									placeholder="Select an answer"
									size="large"
									allowClear
									showSearch
									options={
										data.form_question_options
											? data.form_question_options.map((item, index) => ({
													key: index,
													value: item.option,
													label: item.option,
											  }))
											: []
									}
									onChange={(e) => handleChange(e)}
								/>
							</Form.Item>

							{form_question_options &&
							form_question_options.question_option ? (
								<Typography.Text strong>
									{form_question_options.question_option}
								</Typography.Text>
							) : null}

							{form_question_options &&
							form_question_options.sub_option_type ? (
								<QuestionSubOption
									data={data}
									subData={form_question_options}
									subAnswer={subAnswer}
									handleChange={handleChange}
									isOthers={
										sub_option && sub_option.scale === "others" ? true : false
									}
								/>
							) : null}
						</>
					);
				}}
			</Form.Item>
		);
	} else if (data && data.question_type === "Date (Datepicker)") {
		return (
			<Form.Item
				name={`q_${data.id}`}
				rules={[
					{
						required: data.required ? true : false,
						message: "Please answer the question!",
					},
				]}
			>
				<DatePicker
					size="large"
					format={{
						format: "MM/DD/YYYY",
						type: "mask",
					}}
					onChange={(date, dateString) => {
						handleChange(dateString);
					}}
				/>
			</Form.Item>
		);
	} else if (data && data.question_type === "Time (Timepicker)") {
		return (
			<Form.Item
				name={`q_${data.id}`}
				rules={[
					{
						required: data.required ? true : false,
						message: "Please answer the question!",
					},
				]}
			>
				<DatePicker
					size="large"
					format={{
						format: "HH:mm:ss",
						type: "mask",
					}}
					onChange={(date, dateString) => {
						handleChange(dateString);
					}}
				/>
			</Form.Item>
		);
	} else {
		return null;
	}
}
